import styled from '@emotion/styled';


export const AddNewCollection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;
`;
